/**
 * The ticket a search term names with a `#`, or null.
 *
 * Shared by the two boxes that act on it -- the sidebar's search, where Enter
 * opens the ticket, and the palette, where the highlight starts on it.
 *
 * Stricter than the API's `ticketIdFromSearch`, which also reads a bare
 * "1234": that one decides ranking, where a wrong guess costs a row's
 * position. This one decides what Enter opens, and a bare number is as often
 * an order or a customer id -- only the `#` makes it unambiguous.
 */
export function ticketIdFromTerm(term: string): number | null {
  const match = /^#(\d{1,9})$/.exec(term.trim());
  if (!match) return null;
  const id = Number(match[1]);
  return id > 0 ? id : null;
}
